import { z } from 'zod';

export const publicWebinarFullnameRequestSchema = z.object({
    token: z.string(),
    fullname: z.string(),
});
export type PublicWebinarFullnameRequest = z.infer<typeof publicWebinarFullnameRequestSchema>;

export const publicWebinarUrlSchema = z.object({
    redirectUrl: z.string(),
});
export type PublicWebinarUrl = z.infer<typeof publicWebinarUrlSchema>;

export const publicWebinarGetDateRequestSchema = z.object({
    token: z.string(),
});
export type GetPublicWebinarDataRequest = z.infer<typeof publicWebinarGetDateRequestSchema>;

export const publicWebinarData = z.object({
    dateStart: z.string(),
    title: z.string(),
});
export type PublicWebinarData = z.infer<typeof publicWebinarData>;
